import React, { useEffect, useState } from "react";
import WalletItem from "./WalletItem";
import { editIcon } from "../../../Base/SVG";
import { motion } from "framer-motion";
import { fetchWalletSettings } from "../../../redux/wallet/action";
import { useDispatch, useSelector } from "react-redux";
import useWallet from "../../../utils/hooks/useWalletConnect";
import { networkIcons, tokenIcons } from "../../../utils/constants";
import { updateWallet } from "../../../redux/wallet/api";
import { toast } from "react-toastify";
import Web3 from "web3";
import useToast from "../../../utils/hooks/useToast";
import useSignature from "../../../utils/hooks/useSignature";

export default function Wallets() {
  const dispatch = useDispatch();
  const web3 = new Web3(window.ethereum);
const {showToast}=useToast()
  const { signature, nonce } = useSelector(({ user }) => user);
  const { walletSettings } = useSelector(({ wallet }) => wallet);
  const { account,isConnected } = useWallet();
  const { isSignIn,getAuth } = useSignature();
  const [isLoading, setIsLoading] = useState(true);
  const [form, setForm] = useState({
    wallets: [
      {
        id: "3",
        address: "0x0324d...a1ea3",
        network: "BSC",
        networkIcon: "/images/networks/binance.svg",
        status: false,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
      {
        id: "2",
        address: "0x0324d...a1ea3",
        network: "ETH",
        networkIcon: "/images/networks/eth.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: true,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
      {
        id: "3",
        address: "0x0324d...a1ea3",
        network: "AVAX",
        networkIcon: "/images/networks/avalanche.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "1",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },

      {
        id: "1",
        address: "0x0324d...a1ea3",
        network: "POLYGON",
        networkIcon: "/images/networks/polygon.svg",
        status: true,
        coins: [
          {
            id: "1",
            coin: "BUSD",
            coinIcon: "/images/networks/binance.svg",
            status: true,
          },
          {
            id: "2",
            coin: "USDT",
            coinIcon: "/images/tokens/tether.svg",
            status: false,
          },
          {
            id: "3",
            coin: "USDC",
            coinIcon: "/images/tokens/USDC.svg",
            status: false,
          },
          {
            id: "4",
            coin: "DAI",
            coinIcon: "/images/tokens/DAI.svg",
            status: false,
          },
        ],
      },
    ],
  });
  useEffect(() => {
    if (Object.keys(walletSettings.data).length) {
      const transformedData = transformData(walletSettings.data.networks);
      setForm(transformedData);
      // setFormInitialState(JSON.parse(JSON.stringify(transformedData)));
    }
  }, [walletSettings.data]);

  const transformData = (data) => {
    const networks = Object.keys(data);
    const transformedNetworks = networks.map((network) => {
      const tokens = Object.keys(data[network].tokens);
      const transformedTokens = tokens.map((token) => {
        const { tokenContract, accepted } = data[network].tokens[token];
        return {
          id: token,
          coin: token,
          coinIcon: tokenIcons[token],
          status: accepted,
          tokenContract: tokenContract,
        };
      });

      return {
        id: network,
        address: data[network].paymentAddress,
        network: network,
        networkIcon: networkIcons[network],
        status: data[network].accepted,
        coins: transformedTokens,
      };
    });

    return {
      wallets: transformedNetworks,
    };
  };

  useEffect(() => {
    if ((!!account && !!signature)) {
      const payload = {
        $auth: getAuth,
      };
      dispatch(fetchWalletSettings(payload));
    }
  }, [account, signature]);

  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };

  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    lazyDummy();
  }, []);

  const resetAll = () => {
    if (Object.keys(walletSettings.data).length) {
      const transformedData = transformData(walletSettings.data.networks);
      setForm(transformedData);
    }
  };

  const transformDataForApi = (data) => {
    return data.reduce((acc, curr) => {
      let tokens = curr.coins.reduce((acc2, curr2) => {
        acc2[curr2.id] = { accepted: curr2.status };
        return acc2;
      }, {});

      acc[curr.id] = {
        paymentAddress: curr.address,
        accepted: curr.status,
        tokens: tokens,
      };

      return acc;
    }, {});
  };
  const checkIfValidAddres = (add) => web3.utils.isAddress(add);

  const onSave = async () => {
    const networks = transformDataForApi(form.wallets);
    const check = Object.values(networks).every((x) =>
      checkIfValidAddres(x.paymentAddress)
    );
    if (!check) {
      return showToast("Please enter valid address", "error");
    }
    const payload = {
      $auth: getAuth,
    };
    payload.networks = networks;

    try {
      await toast.promise(updateWallet(payload), {
        pending: "Updating wallets...",
        success: "Wallets updated sucessfully!",
        error: "Wallet update failed!",
      });
      dispatch(fetchWalletSettings({ $auth:payload.$auth}))

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="wallets">
        <div className="auto__container">
          {isLoading ? (
            <>
              <h3 className="placeholder"></h3>
              <div className="wallets__inner box">
                <div className="invoiceTable__body">
                  <div className="placeholder"></div>
                  {[0, 1, 2, 3].map((item, index) => {
                    return <div className="placeholder" key={index}></div>;
                  })}
                </div>
              </div>
              <h3 className="placeholder"></h3>
              <div className="wallets__inner box">
                <div className="invoiceTable__body">
                  <div className="placeholder"></div>
                  {[0, 1, 2, 3].map((item, index) => {
                    return <div className="placeholder" key={index}></div>;
                  })}
                </div>
              </div>
            </>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              exit={{ opacity: 0, y: 10 }}
            >
              <h3>Wallets</h3>
              <div className="wallets__inner box">
                {form.wallets.map((item, index) => {
                  return (
                    <WalletItem
                      form={form}
                      updateForm={updateForm}
                      itemData={item}
                      key={index}
                      index={index}
                    />
                  );
                })}
                <div className="wallets__inner-footer">
                  <button
                  disabled={!isConnected || !isSignIn}
                    type="button"
                    className="button bordered"
                    onClick={resetAll}
                  >
                    Reset All
                  </button>
                  <button
                  disabled={!isConnected || !isSignIn}

                    type="button"
                    className="button primary"
                    onClick={onSave}
                  >
                    Save
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>
      <div className="start">
        <div className="auto__container">
          <h3>How to start?</h3>
          <div className="start__inner box">
            <div className="startItem">
              <div className="startItem__number">
                <span>01</span>
              </div>
              <p className="lg">Paste your wallet address</p>
              <div className="input">
                <input type="text" defaultValue="0x0324d...a1ea3" />
                <button className="button" type="button">
                  {editIcon}
                </button>
              </div>
            </div>
            <div className="start__arrow">
              <img
                src={process.env.PUBLIC_URL + "/images/arrow.png"}
                alt="arrow"
              />
            </div>
            <div className="startItem">
              <div className="startItem__number">
                <span>02</span>
              </div>
              <p className="lg">Activate network</p>
              <div className="check">
                <div className="check__row">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/networks/binance.svg"
                    }
                    alt="networks"
                  />
                  <p>Smart Chain</p>
                </div>
                <div className="checkInput">
                  <input type="checkbox" checked={true} />
                  <label htmlFor=""></label>
                </div>
              </div>
            </div>
            <div className="start__arrow">
              <img
                src={process.env.PUBLIC_URL + "/images/arrow.png"}
                alt="arrow"
              />
            </div>
            <div className="startItem">
              <div className="startItem__number">
                <span>03</span>
              </div>
              <p className="lg">Turn on tokens</p>
              <div className="check">
                <div className="check__row">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/networks/binance.svg"
                    }
                    alt="coin"
                  />
                  <p>BUSD</p>
                </div>
                <div className="checkInput">
                  <input type="checkbox" checked={true} />
                  <label htmlFor=""></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
